import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'

import { PaymentListingsV4Wrapper } from '../../components'

export default function SeasonReportPage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <PaymentListingsV4Wrapper
        organization={organization}
        isSeasonReport={true}
      />
    </ModalProvider>
  )
}
